

export default {
  name: "label",
  nickname: "文本",
  desc: "坐标轴指示器的文本标签。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc:
        '是否显示文本标签。如果 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.axisPointer.type">tooltip.axisPointer.type</a> 设置为 <code class="codespan">&#39;cross&#39;</code> 则默认显示标签，否则默认不显示。',
      value: false,
      defaultValue: false,
    },
    precision: {
      name: "precision",
      nickname: "数值",
      desc:
        '文本标签中数值的小数点精度。默认根据当前轴的值自动判断。也可以指定如 <code class="codespan">2</code> 表示保留两位小数。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc: "文本标签文字的格式化器。",
    },
    margin: {
      name: "margin",
      nickname: "外边距",
      desc: "label 距离轴的距离。",
      value: 3,
      defaultValue: 3,
      type: "pureValue",
    },
    color: {
      name: "color",
      nickname: "颜色",
      desc: "文字的颜色。",
      value: "#fff",
      defaultValue: "#fff",
      type: "pureValue",
      eType: "color",
    },
    fontStyle: {
      name: "fontStyle",
      nickname: "字体样式",
      desc: "文字字体的风格",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontWeight: {
      name: "fontWeight",
      nickname: "字体粗细",
      desc: "文字字体的粗细",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontFamily: {
      name: "fontFamily",
      nickname: "字体",
      desc: "文字的字体系列",
      value: "sans-serif",
      defaultValue: "sans-serif",
      type: "pureValue",
    },
    fontSize: {
      name: "fontSize",
      nickname: "字体大小",
      desc: "文字的字体大小",
      value: 12,
      defaultValue: 12,
      type: "pureValue",
    },
    lineHeight: {
      name: "lineHeight",
      nickname: "行高",
      desc: "行高。",
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc:
        '文字块的宽度。一般不用指定，不指定则自动是文字的宽度。在想做表格项或者使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    height: {
      name: "height",
      nickname: "高度",
      desc:
        '文字块的高度。一般不用指定，不指定则自动是文字的高度。在使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    textBorderColor: {
      name: "textBorderColor",
      nickname: "文本边框颜色",
      desc: "文字本身的描边颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textBorderWidth: {
      name: "textBorderWidth",
      nickname: "文本边框宽度",
      desc: "文字本身的描边宽度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowColor: {
      name: "textShadowColor",
      nickname: "文本阴影宽度",
      desc: "文字本身的阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textShadowBlur: {
      name: "textShadowBlur",
      nickname: "文本阴影长度",
      desc: "文字本身的阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetX: {
      name: "textShadowOffsetX",
      nickname: "文本阴影X偏移",
      desc: "文字本身的阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetY: {
      name: "textShadowOffsetY",
      nickname: "文本阴影Y偏移",
      desc: "文字本身的阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc:
        "axisPointer内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。",
      value: [5, 7, 5, 7],
      defaultValue: [5, 7, 5, 7],
      type: "pureValue",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc:
        '文本标签的背景颜色，默认是和 <a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.axisLine.lineStyle.color">axis.axisLine.lineStyle.color</a> 相同。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "文本标签的边框颜色。",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "文本标签的边框宽度。",
      value: 0,
      defaultValue: 0,
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
      value: 3,
      defaultValue: 3,
      type: "pureValue",
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
      value: "#aaa",
      defaultValue: "#aaa",
      type: "pureValue",
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
  },
}
